export default __webpack_public_path__ + "static/realWorldImage2-e33b38d49a9baf650cee996728e08b2f.webp";